import { colors } from '../../colors';
var book = {
  fieldBorderColor: colors.graphite,
  errorColor: colors.warningRed
};
export default book;